<template>
  <div>
    <div class="bg"></div>
    <div class="content">
      <div class="info">
        <div class="photo">
          <img class="doc-avatar" :src="doctorData.certifyImg || doctorImg">
        </div>
        <div class="detail">
          <div class="name-title">
            <span class="name">{{ doctorData.name }}</span>
            <span class="title">{{ doctorData.professionalCodeName }}</span>
            <span class="title">{{ doctorData.departmentCertName }}</span>
          </div>
          <div class="company">
            <p class="hospital">{{ doctorData.firstOrgName }}</p>
          </div>
        </div>
      </div>
      <div class="block">
        <p class="skill">
          <strong class="skill-title">擅长：</strong>
          {{ doctorData.professional }}
        </p>
        <p class="skill">
          <strong class="skill-title">简介：</strong>
          {{ doctorData.personalProfile }}
        </p>
      </div>
      <div class="patient-appraise" v-if="total > 0">
        <div class="appraise-title">患者评价({{ total }})</div>
        <!-- 患者评价列表 begin -->
        <div v-if="finished && list.length <= 0">暂无患者评价</div>
        <div v-else class="advice-list">
          <van-pull-refresh v-model="refreshing" @refresh="getListData(true)">
            <van-list :loading="loading" :finished="finished" :error="error" finished-text="没有更多了" @load="getListData">
              <div class="block appraise-content" v-for="item in list" :key="item">
                <div class="appraise-content-title">
                  <div class="patient-info">
                    <img class="patient-avatar"
                      :src="item.photo || (item.patientGender === 1 ? patientMaleImg : patientFemaleImg)">
                    <div class="patient-name">{{ item.patientName }}</div>
                    <div :class="['patient-channel', getMed(item.medClass).class]">{{ getMed(item.medClass).name }}</div>
                  </div>
                  <van-rate v-model="item.stars" :count="5" :size="15" :gutter="2" color="#FFCA1E" void-icon="star"
                    void-color="#eee" readonly allow-half />
                </div>
                <div class="desc-list">
                  <div class="desc-item" v-for="des in item.tags" :key="des">{{ des }}</div>
                </div>
                <div class="appraise-info">{{ item.content }}</div>
                <div class="appraise-date">{{ item.gmtModified }}</div>
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
        <!-- 患者评价列表 end -->
      </div>
    </div>
  </div>
</template>

<script>
import doctorImg from '@/assets/doctor_default.png';
import patientMaleImg from '@/assets/patient_male.png';
import patientFemaleImg from '@/assets/patient_female.png';

import { getDoctorInfo, getComments } from '@/api/work/doctor';

export default {
  data() {
    return {
      doctorImg,
      patientMaleImg,
      patientFemaleImg,
      id: '',
      loading: false,
      finished: false,
      error: false,
      refreshing: false,
      pageSize: 10,
      pageNo: 1,
      total: 0,
      doctorData: {},
      list: [],
      hospitalId: '',
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.hospitalId = this.$route.query.hospitalId;
    this.getDoctorDetail();
    this.getListData();
  },
  methods: {
    getMed(med) {
      switch (med) {
        case 1: return { name: '图文问诊', class: 'med-teletext', }
        case 2: return { name: '视频问诊', class: 'med-video', }
        case 3: return { name: '语音问诊', class: 'med-voice', }
        default: return '';
      }
    },
    // 获取医生详情
    async getDoctorDetail() {
      const res = await getDoctorInfo({
        doctorId: this.id,
        hospitalId: this.hospitalId,
      });
      if (res.success) {
        this.doctorData = res.data;
      }
    },
    /**
     * 获取评价列表
     */
    getListData(refreshing) {
      if (this.loading) return;
      this.loading = true;

      if (refreshing) {
        this.finished = false;
        this.error = false;
        this.pageNo = 1;
        this.list = [];
      }

      if (this.finished) return;

      getComments({
        doctorId: this.id,
        pageSize: this.pageSize,
        pageNo: this.pageNo,
      }).then((res) => {
        console.log(res, 'res');
        // debugger;
        if (res.success && res.data.list) {
          this.list = this.list.concat(res.data.list);
          this.total = Number(res.data.total);

          this.loading = false;

          if (this.refreshing) this.refreshing = false;

          // 判断是否加载完毕
          if (Number(res.data.total) <= this.list.length) {
            this.finished = true;
          } else {
            this.pageNo += 1;
          }
        } else {
          this.error = true;
          this.loading = false;
          this.finished = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.bg {
  height: 250px;
  padding: 20px;
  background: linear-gradient(180deg, #f3fff9 0%, #f6f7f9 100%);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 1;
}

.content {
  margin-bottom: 40px;
  position: relative;
  z-index: 2;
}

.info {
  padding: 20px;
  box-sizing: border-box;

  @include flex(center);

  .photo {
    margin-right: 12px;

    .doc-avatar {
      width: 60px;
      border-radius: 50%;
      height: 60px;
    }
  }

  .detail {
    width: calc(100% - 72px);

    @include font(13px, 18px, $primary-text-color);
  }

  .name-title {
    margin-bottom: 8px;

    @include flex(center);
  }

  .name {
    font-weight: $font-bold;

    @include font(18px, 25px);
  }

  .title {
    margin: 0 8px;
  }

  .company {
    color: $secondary-text-color;

    @include flex();

    .department {
      flex-shrink: 0;
      max-width: 80px;

      @include line-ellipsis;
    }

    .hospital {
      width: 100%;

      @include line-ellipsis;
      @include font(13px, 18px, #666);
    }
  }
}

.block {
  margin: 0 15px;
  padding: 15px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: $regular-border-radius;

  @include font(15px, 23px, #666);

  .skill {
    &:nth-child(1) {
      margin-bottom: 20px;
    }

    .skill-title {
      font-weight: 500;

      @include font(15px, 23px, $primary-text-color);
    }
  }
}

.patient-appraise {
  margin: 20px 0;

  .appraise-title {
    font-weight: 600;

    @include font(18px, 25px, $primary-text-color);

    margin: 0 0 12px 15px;
  }

  .appraise-content {
    margin-bottom: 12px;

    .appraise-content-title {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .patient-info {
        display: flex;
        align-items: center;

        .patient-avatar {
          width: 25px;
          height: 25px;
          border-radius: 50%;
        }

        .patient-name {
          margin: 0 12px;

          @include font(15px, 22px, $primary-text-color);
        }

        .patient-channel {
          background: #edffed;
          border-radius: 4px;

          @include font(12px, 17px, #3CB979);

          padding: 2px 6px;
          box-sizing: border-box;
        }

        .med-teletext {
          background: #eff5ff;
          color: #3d86ff;
        }

        .med-video {
          background: #f2ebff;
          color: #7a35ef;
        }

        .med-voice {
          background: #fff7e7;
          color: #ff7e46;
        }
      }
    }

    .desc-list {
      @include font(13px, 18px, #666);

      margin-top: 12px;
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: wrap;

      .desc-item {
        background: #f5f5f5;
        border-radius: 13px;

        @include font(13px, 18px, #666);

        padding: 4px 10px;
        box-sizing: border-box;
        margin-right: 10px;
        margin-bottom: 8px;
      }
    }

    .appraise-info {
      @include font(15px, 25px, $primary-text-color);

      margin-bottom: 8px;
    }

    .appraise-date {
      @include font(12px, 17px, #999);
    }
  }
}
</style>
